import gql from "../gql";
export default gql `
  fragment Streak on LearnerStreak {
    id
    learnerId
    learnerTbid
    apiName
    state
    duration
    longestDuration
    completedFrom
    completedAt
    encourageAt
    atRiskAt
    endsAt
    updatedAt
    learnMoreUrl
  }
`;
